import styled from 'styled-components';
import { getMediaQueriesMFByTheme } from '../../utils';

const ErrorContainer = styled.div`
    min-height: 100vh;
    flex: 1;
    display: flex;
    flex-direction: column;
    width: 100%;
    @supports (min-height: 100dvh) {
        min-height: 100dvh;
    }
    @media ${({ theme }) => getMediaQueriesMFByTheme(theme).mobile} {
        min-height: 100%;
    }
    justify-content: flex-start;
`;

const ErrorHeader = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
`;

const ErrorIconImage = styled.img`
    width: 120px;
    height: 120px;
`;

const ErrorTitle = styled.p`
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    padding: 0 16px;
`;

const ErrorActions = styled.div`
    display: flex;
    flex-direction: column;
    gap: 32px;
    width: 100%;
    padding-top: 32px;
    @media ${({ theme }) => getMediaQueriesMFByTheme(theme).mobile} {
        flex-direction: row;
        justify-content: center;
    }
`;

const ErrorButton = styled.button`
    width: 100%;
    cursor: pointer;
    background-color: #e60000;
    height: 44px;
    border: none;
    border-radius: 6px;
    font-size: 14px;
    line-height: 1;
    color: #ffffff;
    min-width: 355px;
    @media ${({ theme }) => getMediaQueriesMFByTheme(theme).mobile} {
        width: 160px;
        height: 48px;
        font-size: 16px;
    }
`;

export { ErrorContainer, ErrorHeader, ErrorIconImage, ErrorTitle, ErrorActions, ErrorButton };
